import { Action, Reducer, ActionCreatorsMapObject } from 'redux';

import { ApplicationState, AppThunkAction } from '@app/store/index';

export interface Image {
	id: number;
	imageId: number;
}

interface All {
	all: true;
	id: number;
}

export interface State {
	values: Array<Image>;
	all: null | All;
}

export enum TypeKeys {
	SELECTALL = 'SELECTALL',
	REMOVE = 'REMOVE',
	CHANGEPLACE = 'CHANGEPLACE',
	REMOVEALL = 'REMOVEALL',
}

interface SelectAll {
	type: TypeKeys.SELECTALL;
	id: number;
	imageIds: Array<number>;
}

interface Remove {
	type: TypeKeys.REMOVE;
	imageId: number;
}

interface Change {
	type: TypeKeys.CHANGEPLACE;
	id: number;
	imageId: number;
}

interface RemoveAll {
	type: TypeKeys.REMOVEALL;
	id: number;
}

const InitialState = {
	all: null,
	values: [],
};

export type Actions = SelectAll | Remove | Change | RemoveAll;

export interface ActionCreators extends ActionCreatorsMapObject {
	add: (id: number, imageIds: Array<number>) => AppThunkAction<Actions>;
	remove: (imageId: number) => AppThunkAction<Actions>;
	change: (id: number, imageId: number) => AppThunkAction<Actions>;
}

export const actionCreators = (dispatch, getState?: () => ApplicationState) => ({
	add: (id: number, imageIds: Array<number>) => {
		dispatch({ type: TypeKeys.SELECTALL, id, imageIds });
	},
	remove: (imageId: number) => {
		dispatch({ type: TypeKeys.REMOVE, imageId });
	},
	change: (id: number, imageId: number) => {
		dispatch({ type: TypeKeys.CHANGEPLACE, id, imageId });
	},
	removeAll: (id: number) => {
		dispatch({ type: TypeKeys.REMOVEALL, id });
	},
});

export const reducer: Reducer<State> = (
	state: State = InitialState,
	incomingAction: Action = { type: '' },
) => {
	const action = incomingAction as Actions;

	switch (action.type) {
		case TypeKeys.SELECTALL:
			return {
				values: action.imageIds.map((imageId) => ({ imageId, id: action.id })),
				all: { all: true, id: action.id },
			};
		case TypeKeys.REMOVE:
			return { values: state.values.filter(({ imageId }) => imageId !== action.imageId), all: null };
		case TypeKeys.CHANGEPLACE:
			return {
				values: state.values
					.filter(({ imageId }) => imageId !== action.imageId)
					.concat({ id: action.id, imageId: action.imageId }),
				all: null,
			};
		case TypeKeys.REMOVEALL:
			return { values: state.values.filter(({ id }) => id !== action.id), all: null };
		default:
			return state;
	}
};
